import React, { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { reportsActions } from "../../_store/reports.slice";
import { GenerateOrderBaseReport } from "../reports/GenerateOrderBaseReport";
import { AddressMultiSelect, ContractorMultiSelect } from "../../_components/Contractors/ContractorMultiSelect";
import { FormControl } from "../../_components/Forms/FormControl";
import { HorizontalView } from "../../_components/Abstractions/HorizontalView";
import { MultiSelectFilter } from "../../_components/Abstractions/MultiSelect/MultiSelectFilter";
import { OrderStatus } from "../../domain/Orders/OrderStatus";
import { TransactionType } from "../../domain/TransactionType";
import { FilterProvider } from "../../_components/Forms/FilterContext";
import { useFormContext } from "react-hook-form";
import { OrderWasteReportGroup } from "./OrderWasteReportGroup";
import { WastesKindsMultiSelect } from "../contractors/Extensions/CreateContractor/WastesKindsMultiSelect";
import { DomainSwitch } from "../../_components/Abstractions/DomainSwitch";
import { WastesMultiSelect } from "../contractors/Extensions/CreateContractor/WastesMultiSelect";

export function GenerateOrdersWasteReport() {
  const renderData = (data) => {
    const result = data ?? {};

    return (
      <div className="mt-2">
        <div className="mb-4"></div>
        <OrderWasteReportGroup result={result} fullReport />
      </div>
    );
  };

  return (
    <GenerateOrderBaseReport
      reportTitle="Raport Zlecenia - Towary"
      reportType="orderWaste"
      renderData={renderData}
      customControls={<GenerateOrdersReportFilters/>}
      renderDefaultControls={false}
      reportAction={reportsActions.generateOrderWastesReport}
    />
  );
}

const GenerateOrdersReportFilters = () => {
  const { setValue, getValues } = useFormContext()
  // const [searchParams, setSearchParams] = useSearchParams();
  // const splitWastesKinds = watch("splitWastesKinds");

  const onFilterChanged = (param) => {
    const { name, value } = param;
    setValue(name, value);
    updateUrlParams();
  }

  // Update URL whenever form values change
  const updateUrlParams = () => {
    }

  return <div className="d-flex flex-column align-items-start">
    <>Kontrahenci</>
    <ContractorMultiSelect name="contractorsIds" label="Kontrahenci" onChange={updateUrlParams}/>
    <>Adresy</>
    <AddressMultiSelect name="addressesIds" label="Adresy" onChange={updateUrlParams}/>
    <div className="mb-2">
      <>Towary</>
      <WastesMultiSelect name="wastesIds" required={false} onChange={updateUrlParams}/>
      <div className="mt-2"></div>
      <>Towary z podziałem na gatunki</>
      <WastesKindsMultiSelect
        name="wastesKinds"
        includeAllWasteKinds
        required={false}
        optionSave={(x) => ({ wasteId: x.wasteId, wasteKindId: x.wasteKindId })}
        onChange={updateUrlParams}/>
      {/*<DomainSwitch name="splitWastesKinds" label="Towary z podziałem na gatunki" className="mt-2" onChange={updateUrlParams}/>*/}
    </div>
    <HorizontalView>
      <FilterProvider onFilterChange={onFilterChanged} defaultValues={[]}>
        <MultiSelectFilter name="orderStatuses" className="x-small" options={OrderStatus} title="Status"/>
        <MultiSelectFilter name="transactionTypes" className="x-small" options={TransactionType} title="Typ transakcji"/>
      </FilterProvider>
    </HorizontalView>
    <HorizontalView>
    </HorizontalView>
    <HorizontalView>
      <FormControl name="dateFrom" label="Dzień od" inputType="date" onChange={updateUrlParams}/>
      <FormControl name="dateTo" label="Dzień do" inputType="date" onChange={updateUrlParams}/>
    </HorizontalView>
  </div>;
}